import { authApi } from './authApi';

export const getTatConfig = async (params?: any) => {
  return await authApi.get(`stylus/tat/tatconfig/${params ? params : ''}`);
};

export const postTat = async (payload: any) => {
  return await authApi.post('stylus/tat/tatconfig/', payload);
};

export const postHoliday = async (payload: any) => {
  if (payload?.id) {
    return await authApi.patch(`admin/holiday/${payload.id}/`, payload.body);
  } else {
    return await authApi.post('admin/holiday/', payload.body);
  }
};

export const getHoliday = async () => {
  return await authApi.get('admin/holiday/');
};

export const getDesignationUsers = async () => {
  return await authApi.get('admin/designation/users/');
};

// tat export email config
export const fetchTatEmailConfig = async (): Promise<any> => {
  return await authApi.get('stylus/tat/tat-export-email-config/');
};

export const tatEmailConfigCreate = async (payload: any) => {
  return await authApi.post('stylus/tat/tat-export-email-config/', payload);
};

export const editTatEmailConfig = async (payload: any) => {
  return await authApi.patch(
    `stylus/tat/tat-export-email-config/${payload?.id}/`,
    payload?.body
  );
};
